import recommendation from './recommendation.js';
import playback from './playback.js';

function experience(backendAxiosInstance) {
  return {
    ...recommendation(backendAxiosInstance),
    ...playback(backendAxiosInstance)
  };
}

export { experience as default };
//# sourceMappingURL=index.js.map
